import React from "react";
import { useLocation } from "react-router-dom";

import "./index.scss";

const SingleBlog = () => {
  const location = useLocation();
  const { image, title, body } = location.state;

  return (
    <>
      <div className="single-blog-conainer">
        <img src={`${image}`} alt="name" />
        <h1>{title}</h1>
        <div
          className="blog-body"
          dangerouslySetInnerHTML={{ __html: body.value }}
        ></div>
      </div>
    </>
  );
};

export default SingleBlog;
